export default __webpack_public_path__ + "static/2172-83ea524ccb2237ea669f50173bde703f.gif";